module.exports = __webpack_public_path__ + "static/media/bucaramanga.5f63a9e5.jpeg";